import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const journalTypeApi = generateNomenApi(`/nomen/journal-type`);

export const journalTypeOptions = generateNomenOptions('journal-type', journalTypeApi);
